function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.083c-9.2 0-16.667 7.467-16.667 16.667 0 9.2 7.467 16.667 16.667 16.667 9.2 0 16.667-7.467 16.667-16.667 0-9.2-7.467-16.667-16.667-16.667Zm0 30c-7.367 0-13.333-5.966-13.333-13.333S12.633 7.417 20 7.417s13.333 5.966 13.333 13.333S27.367 34.083 20 34.083Z",
  fill: "#484F5F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.667 23.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM20 23.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM28.333 23.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
  fill: "#484F5F"
});

function SvgIconPendingOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgIconPendingOutline);
export default __webpack_public_path__ + "static/media/icon-pending-outline.4d445762.svg";
export { ForwardRef as ReactComponent };